import { GenericMessageModalProps } from './GenericMessageModal';
import { openModal } from '@core/components/ModalStack';

export async function openGenericMessageModal(props: GenericMessageModalProps) {
  const { GenericMessageModal } = await import('./GenericMessageModal');

  openModal(GenericMessageModal, props);
}
